import React from 'react';
import { motion } from 'framer-motion';
export const Mechanism = () => {
  return <section className="py-12 md:py-24 bg-brand-darker relative overflow-hidden" data-id="element-80">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-blue/5 blur-[150px] pointer-events-none" data-id="element-81"></div>

      <div className="max-w-6xl mx-auto px-4" data-id="element-82">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-83">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1 space-y-4 md:space-y-8" data-id="element-84">
            <div data-id="element-85">
              <h3 className="font-display text-3xl md:text-6xl text-white uppercase leading-none mb-2 md:mb-4" data-id="element-86">
                El Mecanismo: <br data-id="element-87" />
                <span className="text-brand-blue" data-id="element-88">Interrupción de Patrón</span>
              </h3>
              <div className="w-16 md:w-20 h-1 bg-brand-blue mb-4 md:mb-8" data-id="element-89"></div>
            </div>

            <div className="space-y-4 md:space-y-6 text-brand-light text-base md:text-lg leading-relaxed" data-id="element-90">
              <p data-id="element-91">
                La clave es la{' '}
                <strong data-id="element-92">"Interrupción de Patrón Emocional"</strong>. Es una
                técnica de psicología conductual que rompe la expectativa del
                cerebro del otro.
              </p>
              <p data-id="element-93">
                En lugar de recibir el mensaje de "seguidor" que esperan, lanzas
                un{' '}
                <span className="text-white font-semibold border-b border-brand-blue" data-id="element-94">
                  Ancla de Curiosidad
                </span>{' '}
                que abre un bucle mental.
              </p>
              <p data-id="element-95">
                Su cerebro odia las tareas inacabadas; por puro instinto,
                tendrán que escribirte para cerrar ese bucle. Pasas de ser quien
                espera a ser quien controla el flujo de la conversación.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-1 lg:order-2 max-w-sm mx-auto lg:max-w-none" data-id="element-96">
            <img src="https://cdn.magicpatterns.com/uploads/6FtbHHrd75WgkDPuDfo8vx/private_openrouter-generated-image-1777439303523.png" alt="Código Digital WhatsApp" className="w-full h-auto object-cover border border-brand-blue/30 shadow-glow-blue" data-id="element-97" />
          </motion.div>
        </div>
      </div>
    </section>;
};